import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.country;

const getCountry = createSelector(getData, country => values(country));

export default getCountry;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getCountry.js